import { handleActions } from 'redux-actions';
import update from 'immutability-helper';

import {
  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_ERROR,
  VERIFY_CODE,
  VERIFY_CODE_SUCCESS,
  VERIFY_CODE_ERROR,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_ERROR,
} from '../type';

import { initialState } from './initialize-state';

const resetPasswordReducer = handleActions(
  new Map([
    [
      FORGOT_PASSWORD,
      state => {
        return update(state, {
          loadingStatus: {
            forgotPasswordLoading: { $set: true },
          },
        });
      },
    ],
    [
      FORGOT_PASSWORD_SUCCESS,
      state => {
        return update(state, {
          loadingStatus: {
            forgotPasswordLoading: { $set: false },
          },
        });
      },
    ],
    [
      FORGOT_PASSWORD_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            forgotPasswordLoading: { $set: false },
          },
          error: { $set: action.payload },
        });
      },
    ],

    [
      VERIFY_CODE,
      state => {
        return update(state, {
          loadingStatus: {
            verifyCodeLoading: { $set: true },
          },
        });
      },
    ],
    [
      VERIFY_CODE_SUCCESS,
      state => {
        return update(state, {
          loadingStatus: {
            verifyCodeLoading: { $set: false },
          },
        });
      },
    ],
    [
      VERIFY_CODE_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            verifyCodeLoading: { $set: false },
          },
          error: { $set: action.payload },
        });
      },
    ],

    [
      CHANGE_PASSWORD,
      state => {
        return update(state, {
          loadingStatus: {
            changePasswordLoading: { $set: true },
          },
        });
      },
    ],
    [
      CHANGE_PASSWORD_SUCCESS,
      state => {
        return update(state, {
          loadingStatus: {
            changePasswordLoading: { $set: false },
          },
        });
      },
    ],
    [
      CHANGE_PASSWORD_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            changePasswordLoading: { $set: false },
          },
          error: { $set: action.payload },
        });
      },
    ],
  ]),
  initialState,
);

export default resetPasswordReducer;
